/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Awful_Sharp_Capybara_AchieveInputs */

const fr_awful_sharp_capybara_achieve = /** @type {(inputs: Awful_Sharp_Capybara_AchieveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inviter un utilisateur`)
};

/**

* @param {Awful_Sharp_Capybara_AchieveInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const awful_sharp_capybara_achieve = /** @type {((inputs?: Awful_Sharp_Capybara_AchieveInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Awful_Sharp_Capybara_AchieveInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_awful_sharp_capybara_achieve(inputs)
});